export const localizations = [
  { locale: "en", file: () => import("./en.json") },
  { locale: "es", file: () => import("./es.json") },
];
